export default __webpack_public_path__ + "static/media/8.a3033030.png";